import icons from '@assets/icons'
import {
  StyleEmptyTitle,
  StyleEmptyWrapper,
  StyleEmptyDescription,
} from './style'
import SvgImage from '@components/svg'
import useWindowSize from '@hooks/useWindow'
interface IEmpty {
  title?: string
  description?: string
  src?: keyof typeof icons
}
const Empty = ({ title, description, src = 'empty' }: IEmpty) => {
  const { width, height } = useWindowSize()

  const mobile = width < 1024
  return (
    <StyleEmptyWrapper height={height} isMobile={mobile}>
      <SvgImage src={src} width={250} height={250} />
      {!!title && <StyleEmptyTitle>{title}</StyleEmptyTitle>}
      {!!description && (
        <StyleEmptyDescription>{description}</StyleEmptyDescription>
      )}
    </StyleEmptyWrapper>
  )
}
export default Empty
